/** Content-only compare-and-set writes must cover exactly the fields they change. */
export const conditionalContentFields = new Set(['title', 'description', 'priority', 'tags', 'mentions', 'assignee', 'assignees']);

function validValue(field: string, value: unknown): boolean {
  if (['tags', 'mentions', 'assignees'].includes(field)) {
    return Array.isArray(value) && value.every(item => typeof item === 'string');
  }
  if (field === 'priority') return ['low', 'medium', 'high', 'critical'].includes(value as string);
  return typeof value === 'string' || (value === null && ['description', 'assignee'].includes(field));
}

export function validConditionalContentUpdate(data: unknown, expected: unknown): boolean {
  if (!data || typeof data !== 'object' || Array.isArray(data) ||
      !expected || typeof expected !== 'object' || Array.isArray(expected)) return false;
  const fields = Object.keys(data);
  return fields.length > 0 && fields.length === Object.keys(expected).length && fields.every(field =>
    conditionalContentFields.has(field) && Object.prototype.hasOwnProperty.call(expected, field) &&
    validValue(field, (data as Record<string, unknown>)[field]) &&
    validValue(field, (expected as Record<string, unknown>)[field]));
}
